import React, { useState, useContext, useMemo } from "react";
import { IconButton, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";
import ModalStyles from "components/Content/Modal/ModalStyles.module.css";
import Details from "area/employer/EmployeeDashboard/Details";
import Benefits from "components/Content/Table/Benefits"
import Contracts from "components/Content/Table/Contracts";
import Dependents from "components/Content/Table/Dependents";
import FundsBeneficiaries from "components/Content/Table/FundsBeneficiaries";
import PayrollDetails from "components/Content/Table/PayrollDetails";
import useEmployeeEnrollments from "components/Content/Table/useEmployeeEnrollments";
import Reports from 'area/employee/Reports';
// import {getFormattedDate} from 'DateFormat';
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import { PortalNames } from "common/Portals";
import EmployeeBenefitsHistory from "components/Content/Table/EmployeeBenefitsHistory";

import AximTooltip from "components/AximTooltip";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

const axios = require("axios");

function EmployeeDetailMenu({ employeeId, canEdit,reloadEmployees }) {
  const { companyId, userInfo, error, currentPortal } = useContext(PrivateRoutesContext);

  const [openModal, setOpen] = useState(false);
  const [employeeView, setEmployeeView] = useState();
  const [viewDataOnly, setViewDataOnly] = useState();
  const [doShowSubmit, setDoShowSubmit] = useState();
  const [payrollTabActivated, setPayrollTabActivated] = useState(false);

  const isGsg          = useMemo(() => userInfo?.companyDetails?.groupType === "GSG", [userInfo]);
  const isEmployerPortal = currentPortal === PortalNames.Employer.Name;

  const enrollmentsData = useEmployeeEnrollments(employeeView?.employeeID);

  // Payroll tab sits after Dependents (Funds Beneficiary always sits last); its index depends on which conditional tabs render.
  // !isGsg: Details(0) Benefits(1) Contracts(2) H&W(3) Dependents(4) Payroll(5) Funds Beneficiary(6)
  //  isGsg: Details(0) Benefits(1) Dependents(2) Payroll(3) Funds Beneficiary(4)
  const payrollTabIndex = isGsg ? 3 : 5;

  const handleTabSelect = (index) => {
    if (isEmployerPortal && index === payrollTabIndex) {
      setPayrollTabActivated(true);
    }
  };

  const handleEditAction = () => {
    loadEmployee(() => {
      setViewDataOnly(false);
      setDoShowSubmit(true);
      setOpen(true);
    });
  };
  const refreshEmployee = (close) => {
    loadEmployee()
    if(close){
      setOpen(false);
      reloadEmployees();
    }
  }
  const loadEmployee = (action) => {
    apiGet(apiUrls.getEmpView(employeeId)).then(
      (response) => {
        console.log(response.data,'employee view')
        setEmployeeView(response.data);

        if (action) {
          action();
        }
      }
    )
  }

  const handleClose = () => {
    setOpen(false);
    setPayrollTabActivated(false);
  }

  const handleUpdate = () => {
    setOpen(false);
  }
  
  return <>
    <>
        <AximTooltip title="Edit Employee">
          <IconButton color="primary" onClick={handleEditAction}>
            <EditOutlinedIcon />
          </IconButton>
        </AximTooltip>
    </>

    {/* MODAL */}
    {employeeId !== undefined ? (
      <Dialog
        open={openModal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={ModalStyles.empDataModal}
        maxWidth="lg"
      >
        {viewDataOnly ? (
          <DialogTitle id="alert-dialog-title">
            View Employee Details
          </DialogTitle>
        ) : (
          <DialogTitle id="alert-dialog-title">
            Edit Employee Details
          </DialogTitle>
        )}
        <DialogContent className={ModalStyles.CustomTabsWrapper}>
          <Tabs onSelect={handleTabSelect}>
            <TabList >
              <Tab>Details</Tab>
               <Tab>Benefits</Tab>
              {/* {viewDataOnly ? <Tab>Benefits History</Tab> : null} */}
              {!isGsg ? <Tab>Contracts</Tab> : null}
              {!isGsg ? <Tab>{"H&W Statement"}</Tab> : null}
              <Tab>Dependents</Tab>
              {isEmployerPortal ? <Tab>Payroll</Tab> : null}
              <Tab>Funds Beneficiary</Tab>
            </TabList>

            <TabPanel>
            {employeeView !== undefined ? (
                <form noValidate autoComplete="off" className="grid">
                  <Details viewDataOnly={false} fetchedData={employeeView} refreshData={refreshEmployee} />
                </form>
              ) : (
                <h3>No Data Available</h3>
              )}
            </TabPanel>
            <TabPanel>
              {employeeView !== undefined ? (
                <form noValidate autoComplete="off">
                  <Benefits employeeId={employeeView.employeeID} insuredId={employeeView.insuredID} benefitPackageId={employeeView.benefitPackageID} enrollmentsData={enrollmentsData}/>
                </form>
              ) : (
                <h3>No Data Available</h3>
              )}
            </TabPanel>
            {!isGsg && (
            <TabPanel>
              {employeeView !== undefined ? (
                <form noValidate autoComplete="off">
                  <Contracts employeeId={employeeId} companyId={companyId} />
                </form>
              ) : (
                <h3>No Data Available</h3>
              )}
            </TabPanel>
            )}
          {!isGsg && (
            <TabPanel>
              {employeeView !== undefined ? (
                <form noValidate autoComplete="off">
                  <Reports payPeriodsUrl={apiUrls.getHWPayPeriods(companyId)}
                           getHWStatementUrl={(payDate, endDate) => apiUrls.getEmployeeHWStatement(employeeId, companyId, payDate, endDate)}
                           exportUrl={apiUrls.exportEmployeeHWStatement("hwStatement")}/>
                </form>
              ) : (
                <h3>No Data Available</h3>
              )}
            </TabPanel>
          )}
            <TabPanel>
              {employeeView !== undefined ? (
                <Dependents
                  employeeId={employeeView.employeeID}
                  insuredId={employeeView.insuredID}
                />
              ) : (
                <h3>No Data Available</h3>
              )}
            </TabPanel>
            {isEmployerPortal && (
              <TabPanel>
                {payrollTabActivated && employeeView !== undefined ? (
                  <PayrollDetails insuredId={employeeView.insuredID} />
                ) : null}
              </TabPanel>
            )}
            <TabPanel>
              {employeeView !== undefined ? (
                <FundsBeneficiaries
                  insuredId={employeeView.insuredID}
                  activeBenefits={enrollmentsData.activeBenefits}
                />
              ) : (
                <h3>No Data Available</h3>
              )}
            </TabPanel>
          </Tabs>
        </DialogContent>
        <DialogActions className={ButtonStyle.buttonWrapper}>
          <Button 
            variant="outlined"
            color="secondary"
            onClick={handleClose}
            className={ButtonStyle.CcancelBtn}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    ) : null}
  </>;
}

export default EmployeeDetailMenu;
